import React from "react";
import AppCheckbox from "./AppCheckbox";

function defaultGetItemKey(item) {
  if (item && typeof item === "object") {
    return item.value ?? item.key ?? item.id ?? String(item.label ?? "");
  }

  return String(item);
}

function defaultGetItemLabel(item) {
  if (item && typeof item === "object") {
    return item.label ?? item.value ?? item.key ?? item.id ?? "";
  }

  return String(item);
}

function defaultGetItemDescription(item) {
  if (item && typeof item === "object") {
    return item.description ?? null;
  }

  return null;
}

export default function AppSelectionList({
  items = [],
  value = [],
  onChange,
  size = "md",
  getItemKey = defaultGetItemKey,
  getItemLabel = defaultGetItemLabel,
  getItemDescription = defaultGetItemDescription,
  renderLeading = null,
  renderTrailing = null,
  emptyState = "Keine Einträge vorhanden",
  className = "",
  style,
  ...props
}) {
  const selectedValues = Array.isArray(value) ? value : [];

  function isSelected(itemKey) {
    return selectedValues.includes(itemKey);
  }

  function handleItemChange(item, nextSelected) {
    const itemKey = getItemKey(item);
    const nextValue = nextSelected
      ? [...selectedValues, itemKey]
      : selectedValues.filter((entry) => entry !== itemKey);

    onChange?.(nextValue, item, nextSelected);
  }

  const classes = [
    "ds-selection-list",
    size === "sm" ? "ds-selection-list--sm" : "",
    size === "md" ? "ds-selection-list--md" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (!items.length) {
    return (
      <div className={classes} style={style}>
        {typeof emptyState === "string" ? <div className="ds-selection-list__empty">{emptyState}</div> : emptyState}
      </div>
    );
  }

  return (
    <div className={classes} role="list" style={style} {...props}>
      {items.map((item) => {
        const itemKey = getItemKey(item);
        const itemLabel = getItemLabel(item);
        const itemDescription = getItemDescription(item);
        const leadingContent = renderLeading ? renderLeading(item) : null;
        const trailingContent = renderTrailing ? renderTrailing(item) : null;
        const itemDisabled = Boolean(item?.disabled);
        const itemSelected = isSelected(itemKey);

        const rowClasses = [
          "ds-selection-list__row",
          itemSelected ? "ds-selection-list__row--selected" : "",
          itemDisabled ? "ds-selection-list__row--disabled" : "",
        ]
          .filter(Boolean)
          .join(" ");

        const labelContent = (
          <span className="ds-selection-list__label-wrap">
            {leadingContent ? <span className="ds-selection-list__leading">{leadingContent}</span> : null}
            <span className="ds-selection-list__copy">
              <span className="ds-selection-list__label">{itemLabel}</span>
              {itemDescription ? <span className="ds-selection-list__description">{itemDescription}</span> : null}
            </span>
          </span>
        );

        return (
          <div key={itemKey} className={rowClasses} role="listitem">
            <div className="ds-selection-list__row-content">
              <AppCheckbox
                className="ds-selection-list__checkbox"
                alignment="center"
                checked={itemSelected}
                disabled={itemDisabled}
                label={labelContent}
                onChange={(event) => handleItemChange(item, event.target.checked)}
              />
              {trailingContent ? <div className="ds-selection-list__trailing">{trailingContent}</div> : null}
            </div>
          </div>
        );
      })}
    </div>
  );
}
